import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/track";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
      return;
    }
    // Le contenu peut se monter après la navigation (redirections, fonts, images) :
    // on retente le scroll plusieurs fois pour garantir l'arrivée sur l'ancre.
    const id = hash.slice(1);
    const timers = [150, 500, 1000, 1800].map((ms) => setTimeout(() => scrollToId(id), ms));
    return () => timers.forEach(clearTimeout);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
